import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

const BookingManagementPage = () => {
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    // Simulate a backend call to get the bookings
    fetch('/bookings.json')
      .then(response => response.json())
      .then(data => setBookings(data.bookings))
      .catch(error => {
        console.error('Error fetching bookings:', error);
      });
  }, []);

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(rgba(255,255,255,.9), rgba(255,255,255,.9)), url("/bg.png")', backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
      <Navbar />
      <div className="py-10 px-6">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-10">Gestione Prenotazioni</h1>
        {bookings.map((booking, index) => (
        <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md mt-5">
            <div key={index} className="mb-6">
              <h2 className="text-2xl font-bold text-gray-800">Laboratorio: {booking.labName}</h2>
              <h3 className="text-xl font-semibold text-gray-800">Data: {format(new Date(booking.date), 'dd MMMM yyyy', { locale: it })}</h3>
              <ul className="mt-2 text-gray-700">
                {booking.slots.map((slot, slotIndex) => (
                  <li key={slotIndex} className="mt-1">{slot}</li>
                ))}
              </ul>
              <p className="mt-2 text-gray-700"><strong>Username:</strong> {booking.username}</p>
              <p className="mt-2 text-gray-700"><strong>Nome e Cognome:</strong> {booking.firstName} {booking.lastName}</p>
              <p className="mt-2 text-gray-700"><strong>Email:</strong> {booking.email}</p>
              <p className="mt-2 text-gray-700"><strong>Esperimento:</strong> {booking.experimentName}</p>
            </div>
        </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default BookingManagementPage;